import React, { PropTypes } from 'react';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { Button } from 'react-bootstrap';
import axios from './../../constants/axios';
import alert from 'alertify.js';
import InputControl from './../FormTemplate/InputControl';
import SelectAsync from './../FormTemplate/SelectAsync';

class NewBrandForm extends React.Component {

   save = (values) => {
      return axios.post('brands', values)
         .then((res) => {
            if (res.status === 201) {
               alert.success('New Brand Created.');
               this.context.router.push('brand');
            } else {
               alert.error('Something Went Wrong. Call Rasel');
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               throw new SubmissionError(err.response.data);
            } else {
               alert.error('UnExpected error. Call Admin.');
            }
         });
   };

   render() {
      const { handleSubmit, submitting, pristine, invalid } = this.props;
      return (
         <div>
            <h3>New Brand Form</h3>
            <form onSubmit={handleSubmit(this.save)} autoComplete="off" noValidate >
               <Field name="name" component={InputControl} type="text" label="Brand Name" />
               <Field name="manufacturer_id" component={SelectAsync} link="manufacturers/searchByName" />
               <Button type="submit" bsStyle="success" block
                       disabled={submitting || pristine || invalid} >Save</Button>
            </form>
         </div>
      );
   }
}
NewBrandForm.propTypes = {
   handleSubmit: React.PropTypes.func,
   submitting: PropTypes.bool,
   pristine: PropTypes.bool,
   invalid: PropTypes.bool,
   dispatch: PropTypes.func
};

NewBrandForm.contextTypes = {
   router: PropTypes.object.isRequired
};

NewBrandForm = reduxForm({ // eslint-disable-line
   form: 'newBrandForm'
})(NewBrandForm);

export default NewBrandForm;



/** WEBPACK FOOTER **
 ** ./src/components/Brand/NewBrandForm.js
 **/